export default "__VITE_ASSET__DZz2tIPo__"